import React, { useRef, useLayoutEffect } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5radar from "@amcharts/amcharts5/radar";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
var MyGlobalObject={}

//export default function SolidGaugeChart() {

function SolidGaugeChart(props) {
  const chart = useRef(null);

  useLayoutEffect(() => {
    
    //const props = this.props;
    const value_day = props.value.day
    const value_week = props.value.week
    const value_month = props.value.month

    if(value_day >= 0) {

    if(MyGlobalObject[props.id]){   //check if exist chart dispose that
      MyGlobalObject[props.id].dispose()
    }
    
    //let x = am4core.create("chartdiv", am4charts.XYChart);
    let x = am5.Root.new(props.div);
        x.setThemes([
            am5themes_Animated.new(x)
          ]);
          let chart = x.container.children.push(am5radar.RadarChart.new(x, {
            panX: false,
            panY: false,
            //wheelX: "panX",
            //wheelY: "zoomX",
            innerRadius: 20,
            startAngle: -90,
            endAngle: 180
        }));

        let cursor = chart.set("cursor", am5radar.RadarCursor.new(x, {
          //    behavior: "zoomX"
          }));
  
          cursor.lineY.set("visible", false);
          //cursor.lineX.set("visible", false);
  
  
          // Create axes and their renderers
          // https://www.amcharts.com/docs/v5/charts/radar-chart/#Adding_axes
          let xRenderer = am5radar.AxisRendererCircular.new(x, {
              //minGridDistance: 50
          });
  
          xRenderer.labels.template.setAll({
              radius: 10
          });
            
          xRenderer.grid.template.setAll({
              forceHidden: true
          });
  
            const maxValue = 5 + value_month; 
  
          let xAxis = chart.xAxes.push(am5xy.ValueAxis.new(x, {
              renderer: xRenderer,
              min: 0,
              max: maxValue,
              strictMinMax: true,
              //numberFormat: "#'%'",
              numberFormat: "#",
              tooltip: am5.Tooltip.new(x, {})
            }));
            
            
            let yRenderer = am5radar.AxisRendererRadial.new(x, {
              minGridDistance: 20
            });
            
            yRenderer.labels.template.setAll({
              centerX: am5.p100,
              fontWeight: "500",
              fontSize: 18,
              templateField: "columnSettings"
            });
            
            yRenderer.grid.template.setAll({
              //forceHidden: true
            });
            
            let yAxis = chart.yAxes.push(am5xy.CategoryAxis.new(x, {
              categoryField: "category",
              renderer: yRenderer
            }));
  
          const myData = [{
              category: "Today",
              value: value_day,
              full: maxValue
          }, {
              category: "7 days",
              value: value_week,
              full: maxValue
          }, {
            category: "Last month",
            value: value_month,
            full: maxValue
          }]
  
            yAxis.data.setAll(myData);
            
            // Create series
            // https://www.amcharts.com/docs/v5/charts/radar-chart/#Adding_series
            let series1 = chart.series.push(am5radar.RadarColumnSeries.new(x, {
              xAxis: xAxis,
              yAxis: yAxis,
              clustered: false,
              valueXField: "full",
              categoryYField: "category",
              fill: x.interfaceColors.get("alternativeBackground")
            }));
            
            series1.columns.template.setAll({
              width: am5.p100,
              fillOpacity: 0.08,
              strokeOpacity: 0,
              cornerRadius: 20
            });
            
            series1.data.setAll(myData);
            
            //*
            let series2 = chart.series.push(am5radar.RadarColumnSeries.new(x, {
              xAxis: xAxis,
              yAxis: yAxis,
              clustered: false,
              valueXField: "value",
              categoryYField: "category",
              fill: am5.color(0x2dce89)
            }));
            
            series2.columns.template.setAll({
              width: am5.p100,
              strokeOpacity: 0,
              tooltipText: "{category}: {valueX}",
              cornerRadius: 20,
              templateField: "columnSettings"
            });
            
            series2.data.setAll(myData);
            //*/
            // Animate chart and series in
            // https://www.amcharts.com/docs/v5/concepts/animations/#Initial_animation
  
            series1.appear(1000);
            series2.appear(1000);
            chart.appear(1000, 100);

            MyGlobalObject[props.id]=x


    return () => {
      x.dispose();
    };

    }


  }, [props.value]);
  return (
    <div id={props.div} style={{ width: "100%", height: "500px" }}></div>
  );

}

export default SolidGaugeChart;

